export const Themes = {
  primary:
    'bg-primary border border-primary text-light-blue hover:bg-primary/80',
  secondary:
    'hover:bg-secondary/80 border border-secondary bg-secondary text-light-blue',
  success:
    'hover:bg-green-500/80 border border-green-500 bg-green-500 text-light-blue',
  warning:
    'hover:bg-yellow-200/80 border border-yellow-300 bg-yellow-300 text-light-blue',
  error: 'hover:bg-red-500/80 border border-red-500 bg-red-500 text-light-blue',
  light:
    'hover:bg-light-blue/80 border border-secondary hover:text-secondary/80 bg-light-blue text-secondary',
  dark: 'bg-primaryDark border border-primaryDark text-light-blue hover:bg-primaryDark/90',
};
